import React from 'react';
import * as PropTypes from 'prop-types';
import {
    Layout, Row, Typography
} from 'antd';
import './Panels.css';

const { Text } = Typography;


const AlertPanelFrame = ({ image, title, children, level }) => {

    return (
        <Layout className={"dp-panel-frame-outer"}>
            <div className={"dp-alert-panel-header dp-alert-panel-header-" + level} >
                <Row>
                    <span className="dp-alert-panel-frame-title">{image}</span><Text className="dp-alert-panel-frame-title">{title}</Text>
                </Row>
            </div>
            <div className={"dp-alert-panel-body"}>
                <Row className="dp-panel-frame-main">
                    {children}
                </Row>
            </div>
        </Layout>
    );
}

// Validate the prop type parameters.
AlertPanelFrame.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)]).isRequired,
};

export default AlertPanelFrame;
